module.exports = __webpack_public_path__ + "img/home_care.b48a37e3.svg";